import { useDispatch } from 'react-redux';
import { readAllNotifications } from '../../../store/slices/notificationSlice/action';

export const useNotificationHeader = () => {
    const dispatch = useDispatch();

    const readAll = async () => {
        dispatch(readAllNotifications());
    };

    return { readAll };
};
